<template>
    <h4>{{ $t('general.comunicaciones') }}</h4>
    <div class="card">

        <div class="card-body">
            <div class="row">
                <div class="col-md-4" v-if="permisosusuario.includes('Administración') || permisosusuario.includes('Super Administración')">
                    <a @click.prevent="abrirConfiguracion('Centralita')" href="#" class="info-box">
                        <span class="info-box-icon bg-danger"><i class="fas fa-phone-alt"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">{{ $t('general.centralita') }}</span>
                        </div>
                    </a>
                </div>
                <div class="col-md-4" v-if="permisosusuario.includes('Super Administración')">
                    <a @click.prevent="abrirConfiguracion('Correos')" href="#" class="info-box">
                        <span class="info-box-icon bg-danger"><i class="fas fa-at"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">{{ $t('general.correos') }}</span>
                        </div>
                    </a>
                </div>
                <div class="col-md-4" v-if="permisosusuario.includes('soporte') && interpwgs">
                    <a @click.prevent="abrirConfiguracion('Interpwgs')" href="#" class="info-box">
                        <span class="info-box-icon bg-danger"><i class="fas fa-project-diagram"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">{{ $t('general.interpwgs') }}</span>
                        </div>
                    </a>
                </div>
                <div class="col-md-4" v-if="permisosusuario.includes('Administración') || permisosusuario.includes('Super Administración')">
                    <a @click.prevent="abrirConfiguracion('SMS')" href="#" class="info-box">
                        <span class="info-box-icon bg-danger"><i class="fas fa-sms"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">{{ $t('general.sms') }}</span>
                        </div>
                    </a>
                </div>
                <div class="col-md-4" v-if="permisosusuario.includes('Super Administración') || permisosusuario.includes('soporte')">
                    <a @click.prevent="abrirConfiguracion('Sigue tu expediente')" href="#" class="info-box">
                        <span class="info-box-icon bg-danger"><i class="fas fa-house-user"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Sigue tu expediente</span>
                        </div>
                    </a>
                </div>
                <div class="col-md-4" v-if="permisosusuario.includes('Administración') || permisosusuario.includes('Super Administración')">
                    <a @click.prevent="abrirConfiguracion('Auto Visitas')" href="#" class="info-box">
                        <span class="info-box-icon bg-danger"><i class="fas fa-calendar-plus"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Auto Visitas</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { PwgsApi } from '../../../services/PwgsApi';
export default({
    data() {
        return {
            interpwgs:false,
        }
    },
    props:['permisosusuario'],
    setup() {
        
    },
    methods: {
        abrirConfiguracion(configuracion){
            this.$router.push({
                name: configuracion
            });
        },
        async comprobarInterpwgs(){
            const api = new PwgsApi();
            const interpwgs = await api.get('interpwgs-pwgs/1/activo');
            if(interpwgs==1){
                this.interpwgs = true;
            }else{
                this.interpwgs = false;
            }
        }
    },
    mounted() {
        this.comprobarInterpwgs();
    }
})
</script>
